<template>
    <div>
        <section class="section-features">
            <div class="row" style="padding-left:4rem;">
                <template v-if="getArticles.length===0 && !isSearch">
                    <img src="../assets/loading.gif" alt="">
                </template>
                <template v-for="(msg, index) in getArticles">
                    <div v-if="index %3 === 0 && index !==0" :key="index+'a'"
                         style="width:100%; height: 3rem;clear:both;position:relative;margin-top:20px;">
                    </div>
                    <div class="col-1-of-3" :key="index">
                        <div class="nlpsummary" v-if="msg.nlp_summary.length>0">
                            <label ref="nlpsummary__button"
                                   @click="broadcastNLPSummaryEvent({summary:msg.nlp_summary,title:msg.title, url:msg.url})"
                                   for="nlp-navi-toggle" class="nlpsummary__button">
                                <div class="nlpsummary__icon">SUM</div>
                            </label>
                        </div>
                        <div class="recommendation"
                             @click="broadcastRecommendedEvent({title:msg.title, year:msg.year, url:msg.url})"
                             v-if="msg.recommended!=='error_summary'">
                            <label ref="recommendation__button" for="nlp-rec-toggle" class="recommendation__button">
                                <div class="recommendation__icon">REC</div>
                            </label>
                        </div>
                        <a :href="msg.url" target="_blank" style="color:#666;text-decoration: none;">
                            <div class="feature-box">
                                <img :src="msg.image.indexOf('default')==-1?msg.image:getImage()" alt="img">
                                <h3 class="heading-tertiary u-margin-bottom-small" v-html="msg.title"/>
                                <p class="feature-box__text">
                                    {{msg.fdate}}
                                </p>
                            </div>
                        </a>
                    </div>
                </template>
            </div>
        </section>
    </div>
</template>

<script>
    import FlexSearch from "flexsearch"

    export default {
        // name: "BlogItem",
        component: {},
        props: {
            // articles:[]
        },
        data() {
            return {
                year: null,
                index: [],
                isSearch: false,
                start: 0,
                end: 200,
            }
        },
        mounted() {
            if (this.$store.getters.storedArticles.length === 0) {
                let date = new Date();
                let year = date.getFullYear();
                this.getArticlesByYear(year);
            }
        },
        created() {
            this.$eventHub.$on('filter-data', this.getArticlesByYear);
            this.$eventHub.$on('filter-input-data', this.filterFromStoredArticles);
            let that = this;
            setTimeout(function () {
                window.onscroll = function () {
                    setTimeout(() => {
                        manageStickyMenu()
                    }, 0);
                    setTimeout(() => {
                        manageInfiniteScroll()
                    }, 0)
                };

                function manageInfiniteScroll() {
                    let bottomOfWindow =
                        document.documentElement.scrollTop + window.innerHeight >=
                        90 * document.documentElement.offsetHeight / 100;
                    if (bottomOfWindow) {
                        let filtered = [];
                        if (that.$store.getters.storedArticles) {
                            if (that.end < that.$store.getters.storedArticles.length) {
                                that.end += 200;
                                if (that.isSearch) {
                                    // if searching then get data from filtered articles
                                    filtered = that.$store.getters.selectedArticles.slice(that.start, that.end);
                                } else {
                                    filtered = that.$store.getters.storedArticles.slice(that.start, that.end);
                                }
                                that.$store.dispatch('selectedArticles', {data: filtered, isNew: false});
                            }
                        }
                    }
                }

                let navbar = document.getElementById("section-search");
                let sticky = navbar.offsetTop;

                function manageStickyMenu() {
                    if (window.pageYOffset >= sticky) {
                        navbar.classList.add("sticky")
                    } else {
                        navbar.classList.remove("sticky");
                    }
                }
            }, 500);
        },
        beforeDestroy() {
            // this.$eventHub.$off('filter-data');
        },
        computed: {
            getArticles() {
                let articles = !this.$store.getters.selectedArticles ? [] : this.$store.getters.selectedArticles;
                if (this.$store.getters.newArticles) {
                    this.resetSelectRange();
                    this.indexStoredArticles();
                }
                return articles.slice(this.start, this.end);
            }
        },
        methods: {
          getImage(){
            // let randNumber =Math.floor(Math.random() * 16); //0-15
            // let image='./img/download ('+ randNumber +').jpeg';
            let image='./img/background-white.jpg';
            return image;
          },
            resetSelectRange() {
                this.start = 0;
                this.end = 200;
            },
            broadcastNLPSummaryEvent(data) {
                this.$eventHub.$emit('nlp-summary', data)
            },
            broadcastRecommendedEvent(data) {
                this.$eventHub.$emit('nlp-recommended', data)
            },
            getArticlesByYear(year) {
                this.year = year;
                this.isSearch = false;
                this.$store.dispatch('storedArticles', year)
            },
            filterFromStoredArticles(data) {
                let filtered = [];
                this.resetSelectRange();
                this.isSearch = true;
                if (data.length > 2) {
                    filtered = this.index.search({
                        field: "title",
                        query: data
                    });
                    this.$store.dispatch('totalSelectedArticles', filtered.length);
                } else {
                    this.isSearch = false;
                    this.$store.dispatch('totalSelectedArticles', this.$store.getters.storedArticles.length);
                    filtered = this.$store.getters.storedArticles.slice(this.start, this.end);//this.cachedArticles.slice(0,100)
                }
                this.$store.dispatch('selectedArticles', {data: filtered, isNew: false});
            },
            indexStoredArticles() {
                this.index = new FlexSearch({
                    tokenize: "reverse",
                    depth: 3,
                    doc: {
                        id: "id",
                        field: ["title", "date"]
                    }
                });
                this.index.add(this.$store.getters.storedArticles);
            },
        }
    }
</script>

<style scoped>
    img {
        max-height: 30rem;
        max-width: 20rem;
        margin-left: -.7rem;
    }

    .feature-box {
        cursor: pointer;
    }
</style>
